import { FC } from 'react'
import { Tabs } from 'antd'
import PageLayout from '../../../components/page-layout/page-layout'
import { TabsProps } from 'antd/lib'
import styled from 'styled-components'
import ReceptsConfig from './components/receprs/recepts-config'
import useRouteTab from '../../../hooks/use-route-tab'
import { dynamicRoutes } from '../../../constants/routes'
import HelpDrawer from './components/help-drawer/help-drawer'

const TabsStyled = styled(Tabs)`
    .ant-tabs-content {
        height: 100% !important;
    }
    .ant-tabs-tabpane.ant-tabs-tabpane-active {
        height: 100% !important;
        display: flex;
        flex-direction: column;
    }
`

const TabsData: TabsProps['items'] = [
    {
        label: `Ожидаемые`,
        key: 'expected',
        children: <ReceptsConfig config='Ожидаемые' />,
    },
    {
        label: `Завершенные`,
        key: 'completed',
        children: <ReceptsConfig config='Завершенные' />,
    },
]

const tabs = ['expected', 'completed'] as const

interface MaterialsPageProps {}

const MaterialsPage: FC<MaterialsPageProps> = () => {
    const { activeKey, onTabChange } = useRouteTab({
        tabs,
        defaultTab: 'expected',
        getRoute: dynamicRoutes.receiptsMaterialsTab,
    })

    return (
        <PageLayout title={'Приход материала'} beforeUser={<HelpDrawer />}>
            <TabsStyled
                activeKey={activeKey}
                onChange={onTabChange}
                type='card'
                size={'large'}
                items={TabsData}
                style={{ flex: '1 1' }}
            />
        </PageLayout>
    )
}

export default MaterialsPage
